
// extends the navigation
// used for akademie, cert, etc.
// used in "Meine TÜV-Dienste"
$('[data-nav-extended-trigger]').click(function() {
    let clickId = $(this).data('nav-extended-trigger');

    $('[data-nav-extended-trigger]').removeClass('c-nav-list-extended__link--active');
    $('[data-nav-extended-trigger="' + clickId + '"]').addClass('c-nav-list-extended__link--active');

    $('[data-nav-extended-content]').removeClass('c-nav-list-extended__sub-container--active');
    $('[data-nav-extended-content="' + clickId + '"]').addClass('c-nav-list-extended__sub-container--active');
    return false;
});